module.exports = __webpack_public_path__ + "img/removeTeacher.f6ad265e.svg";